const webhooks = {
    page_title: 'Вебхуки',
    title: 'Вебхуки',
    subtitle: 'Вебхуки предоставляют мгновенные обновления по конкретным событиям на ваш URL-адрес конечной точки, обеспечивая мгновенные реакции.',
    create: 'Создать вебхук',
    events: {
        post_register: 'Создать новый аккаунт',
        post_sign_in: 'Войти',
        post_reset_password: 'Сбросить пароль',
    },
    table: {
        name: 'Имя',
        events: 'События',
        success_rate: 'Коэффициент успешности (за 24ч)',
        requests: 'Запросы (за 24ч)',
    },
    placeholder: {
        title: 'Вебхук',
        description: 'Вебхуки предоставляют мгновенные обновления по конкретным событиям на ваш URL-адрес конечной точки, обеспечивая мгновенные реакции. События "Создать новый аккаунт, Войти, Сбросить пароль" теперь поддерживаются.',
        create_webhook: 'Создать вебхук',
    },
    create_form: {
        title: 'Создать вебхук',
        subtitle: 'Добавьте вебхук, чтобы отправлять запросы POST на URL-адрес конечной точки с деталями любых событий пользователей.',
        events: 'События',
        events_description: 'Выберите события-триггеры, при которых Logto будет отправлять запросы POST.',
        name: 'Имя',
        name_placeholder: 'Введите имя вебхука',
        endpoint_url: 'URL-адрес конечной точки',
        endpoint_url_placeholder: 'https://ваш.url.адрес.вебхука',
        endpoint_url_tip: 'Введите HTTPS URL вашей конечной точки, куда будет отправлено тело вебхука при наступлении события.',
        create_webhook: 'Создать вебхук',
        missing_event_error: 'Вы должны выбрать как минимум одно событие.',
        https_format_error: 'Требуется формат HTTPS по соображениям безопасности.',
    },
    webhook_created: 'Вебхук {{name}} был успешно создан.',
};
export default webhooks;
